'use strict';

import baseConfig from './base';

let config = {
};

export default Object.freeze(Object.assign({}, baseConfig, config));



// WEBPACK FOOTER //
// ./src/config/dist.js